import React from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Shop from '../classes/Shop';

import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

import { setPlay360 } from '../redux/actions/FlagActions';
import { BIKE_TYPES } from '../constants/bike';

const MESSAGE_LOADING = 'Loading...';
const MESSAGE_PLAY_360 = 'Play 360';
const MESSAGE_PAUSE_360 = 'Pause 360';

class Estimation extends React.PureComponent {

    getShopUrl() {   
        const { params, bike, color } = this.props;

        return new Shop(bike, color).getShopURL(params);
    }    

    // Play 360 and Shop buttons
    renderButtons = () => {
        if (isMobile) return;
        const { play360, load360 } = this.props;

        return <button disabled={!load360} className="show-360-button button-secondary"
            onClick={() => setTimeout(() => {
                if (play360) {
                    this.props.dispatch(setPlay360({ play360: false }))
                } else {
                    this.props.dispatch(setPlay360({ play360: true }))
                }
            }, 100)}>
            {load360
                ? play360
                    ? MESSAGE_PAUSE_360
                    : MESSAGE_PLAY_360
                : MESSAGE_LOADING}
        </button>
    };

    render() {
        const { bike, date, willLast } = this.props;

        return (
            <div className="bike-will-last">
                <div className="bike-will-last-head">
                    <span className="will-last-time">{bike.wheel} inch {bike.type === BIKE_TYPES.ethos
                        ? "small"
                        : bike.wheel === 20
                            ? "large"
                            : ""} bike</span>
                    {date && willLast.age > 0 &&
                        <div className="will-last-calculate">
                            <span> will last </span>
                            <span className="will-last-time">{willLast.age} year(s)</span>
                            <Tooltip
                                title="Calculated based on an algorithm which takes into consideration average growth rate data as well as the age of the child."
                                position="top"
                                trigger="mouseenter"
                            >
                                <div className="tooltip-ico">?</div>
                            </Tooltip>
                        </div>
                    }
                </div>
                {date && willLast.age <= 0 &&
                    <div className="bike-will-last-head">
                        <span>You are now ready for a next bike</span>
                        <Tooltip
                            title="Calculated based on an algorithm which takes into consideration average growth rate data as well as the age of the child."
                            position="top"
                            trigger="mouseenter"
                        >
                            <div className="tooltip-ico">?</div>
                        </Tooltip>
                    </div>
                }
                {this.renderButtons()}
                <a className="button-primary shop-bike" target="_blank" rel="noopener noreferrer" href={this.getShopUrl()}>Shop bike</a>
            </div>  
            )
    }
}  

// REDUX STATES
const mapStateToProps = state => {
    return {
        params: state.user.params,
        play360: state.flags.play360,
        date: state.user.date,
        bike: state.bike.bike,
        willLast: state.bike.willLast
    }
};

export default connect(mapStateToProps)(Estimation)



// WEBPACK FOOTER //
// ./src/components/Estimation.js